var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rbTooltip simple questionnaireTooltip" }, [
    _c("div", { staticClass: "questionnaireTooltipBody" }, [
      _c("div", [
        _c("strong", [_vm._v(_vm._s(_vm.ord) + ". " + _vm._s(_vm.title))]),
      ]),
      _vm.description
        ? _c("div", { staticClass: "margin-top" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
    ]),
    _vm.canEdit
      ? _c("div", { staticClass: "questionnaireTooltipHint" }, [
          _vm.locked
            ? _c("div", { staticClass: "questionnaireTooltipHintTextLocked" }, [
                _vm._v(" This question is Locked "),
              ])
            : _vm._e(),
          _vm.required
            ? _c(
                "div",
                { staticClass: "questionnaireTooltipHintTextRequired" },
                [_vm._v(" This question is Mandatory ")]
              )
            : _vm._e(),
          !_vm.locked
            ? _c("div", [
                _c("div", { staticClass: "questionnaireTooltipHintText" }, [
                  _c(
                    "strong",
                    { staticClass: "questionnaireEditTooltipHintAction" },
                    [_vm._v("Left click")]
                  ),
                  _vm._v(" - "),
                  _vm.added
                    ? _c("span", [_vm._v("Remove")])
                    : _c("span", [_vm._v("Add")]),
                  _vm._v(" this Question "),
                ]),
                _vm.added
                  ? _c("div", { staticClass: "questionnaireTooltipHintText" }, [
                      _c(
                        "strong",
                        { staticClass: "questionnaireEditTooltipHintAction" },
                        [_vm._v("Right click")]
                      ),
                      _vm._v(" - Set as "),
                      _vm.required
                        ? _c("span", [_vm._v("Optional")])
                        : _c("span", [_vm._v("Mandatory")]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm.isEditUserDefined
      ? _c("div", { staticClass: "questionnaireTooltipHint" }, [
          _vm._m(0),
          _vm.added
            ? _c("div", { staticClass: "questionnaireTooltipHintText" }, [
                _c(
                  "strong",
                  { staticClass: "questionnaireEditTooltipHintAction" },
                  [_vm._v("Right click")]
                ),
                _vm._v(" - Set as "),
                _vm.required
                  ? _c("span", [_vm._v("Optional")])
                  : _c("span", [_vm._v("Mandatory")]),
              ])
            : _vm._e(),
        ])
      : _vm.error
      ? _c("div", { staticClass: "questionnaireTooltipError" }, [
          _c("div", { staticClass: "questionnaireTooltipErrorText" }, [
            _vm._v(" " + _vm._s(_vm.error) + " "),
          ]),
        ])
      : _c("div", { staticClass: "questionnaireTooltipHint" }, [
          _vm.required
            ? _c(
                "div",
                { staticClass: "questionnaireTooltipHintTextRequired" },
                [_vm._v(" This question is Mandatory ")]
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "questionnaireTooltipHintText" }, [
      _c("strong", { staticClass: "questionnaireEditTooltipHintAction" }, [
        _vm._v("Left click"),
      ]),
      _vm._v(" - "),
      _c("span", [_vm._v("Configure")]),
      _vm._v(" this Question "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }